import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Button } from '../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const EXPIRY_MONTHS = Array.from({ length: 12 }, (_, i) => ({ value: i + 1, label: `${i + 1} ay kala` }));
const VAT_RATES = [
  { value: '0', label: '%0' },
  { value: '1', label: '%1' },
  { value: '10', label: '%10' },
  { value: '20', label: '%20' },
];

export const ProductForm = ({ form, setForm, categories, onSubmit, submitLabel }) => (
  <div className="flex flex-col mt-3 min-h-0">
    <div className="space-y-3 overflow-y-auto flex-1 pr-1">
    <div className="space-y-1">
      <Label className="text-xs">{'Ürün Adı'}</Label>
      <Input value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))}
        className="h-10 text-sm bg-[#F2F2F7] border-0 rounded-xl" data-testid="product-name-input" />
    </div>
    <div className="space-y-1">
      <Label className="text-xs">Barkod No</Label>
      <Input value={form.barcode || ''} onChange={e => setForm(p => ({ ...p, barcode: e.target.value }))}
        placeholder="Opsiyonel" className="h-10 text-sm bg-[#F2F2F7] border-0 rounded-xl" data-testid="product-barcode-input" />
    </div>
    <div className="grid grid-cols-2 gap-2">
      <div className="space-y-1">
        <Label className="text-xs">{`Satış Fiyatı (TL)`}</Label>
        <Input type="number" placeholder="0" value={form.default_price || ''}
          onChange={e => setForm(p => ({ ...p, default_price: e.target.value }))}
          className="h-10 text-sm bg-[#F2F2F7] border-0 rounded-xl" data-testid="product-price-input" />
      </div>
      <div className="space-y-1">
        <Label className="text-xs">{`Geliş Fiyatı (TL)`}</Label>
        <Input type="number" placeholder="0" value={form.cost_price || ''}
          onChange={e => setForm(p => ({ ...p, cost_price: e.target.value }))}
          className="h-10 text-sm bg-[#F2F2F7] border-0 rounded-xl" data-testid="product-cost-price-input" />
      </div>
    </div>
    <div className="space-y-1">
      <Label className="text-xs">Kategori</Label>
      <Select value={form.category_id || 'none'} onValueChange={v => setForm(p => ({ ...p, category_id: v }))}>
        <SelectTrigger className="h-10 text-sm bg-[#F2F2F7] border-0 rounded-xl"><SelectValue placeholder={`Seçiniz`} /></SelectTrigger>
        <SelectContent>
          <SelectItem value="none">Kategorisiz</SelectItem>
          {categories.map(c => <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
    <div className="grid grid-cols-2 gap-2">
      <div className="space-y-1">
        <Label className="text-xs">Mevcut Stok</Label>
        <Input type="number" placeholder="0" value={form.current_stock || ''}
          onChange={e => setForm(p => ({ ...p, current_stock: e.target.value }))}
          className="h-10 text-sm bg-[#F2F2F7] border-0 rounded-xl" data-testid="product-stock-input" />
      </div>
      <div className="space-y-1">
        <Label className="text-xs">Min Stok</Label>
        <Input type="number" placeholder="0" value={form.min_stock || ''}
          onChange={e => setForm(p => ({ ...p, min_stock: e.target.value }))}
          className="h-10 text-sm bg-[#F2F2F7] border-0 rounded-xl" data-testid="product-min-stock-input" />
      </div>
    </div>
    <div className="grid grid-cols-2 gap-2">
      <div className="space-y-1">
        <Label className="text-xs">SKT</Label>
        <Input type="date" value={form.expiry_date || ''}
          onChange={e => setForm(p => ({ ...p, expiry_date: e.target.value }))}
          className="h-10 text-sm bg-[#F2F2F7] border-0 rounded-xl" data-testid="product-expiry-input" />
      </div>
      <div className="space-y-1">
        <Label className="text-xs">{`SKT Uyarısı`}</Label>
        <Select value={String(form.expiry_warning_months || 3)} onValueChange={v => setForm(p => ({ ...p, expiry_warning_months: parseInt(v) }))}>
          <SelectTrigger className="h-10 text-sm bg-[#F2F2F7] border-0 rounded-xl"><SelectValue /></SelectTrigger>
          <SelectContent>
            {EXPIRY_MONTHS.map(m => <SelectItem key={m.value} value={String(m.value)}>{m.label}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
    </div>
    <div className="space-y-1">
      <Label className="text-xs font-medium text-gray-700">{`KDV Oranı`} <span className="text-red-500">*</span></Label>
      <Select value={String(form.vat_rate ?? '')} onValueChange={v => setForm(p => ({ ...p, vat_rate: v }))}>
        <SelectTrigger className="h-10 text-sm bg-[#F2F2F7] border-0 rounded-xl" data-testid="product-vat-rate"><SelectValue placeholder="KDV oranı seçiniz" /></SelectTrigger>
        <SelectContent>
          {VAT_RATES.map(r => <SelectItem key={r.value} value={r.value}>{r.label}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
    </div>
    <div className="pt-3 flex-shrink-0">
      <Button onClick={onSubmit} className="w-full bg-[#6b6de3] hover:bg-[#5658c4] rounded-full" data-testid="product-submit-btn">{submitLabel}</Button>
    </div>
  </div>
);
